export function cleanupEmailAddress(emailAddress: string): string {

	// Trim string
	const cleaned = (emailAddress || "").trim();

	// If we have an empty string, abort
	if (cleaned === "") {
		return "";
	}

	// Validating email address
    // Also allow for merge tags before the @ sign
    // ie [[organization_name]]@gmail.com
	const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|\[\[[a-zA-Z0-9_:-]+\]\])@((\[[0-9]{1,3}(\.[0-9]{1,3}){3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // Allow for a solo merge tag
    // ie [[customer_email_address]]
    const mergeTagPattern = /^\[\[[a-zA-Z0-9_:-]+\]\]$/;
    if (pattern.test(cleaned) || mergeTagPattern.test(cleaned)) {
		return cleaned.toLowerCase();
	}

	return "";
}

export function hasValidEmail(emailAddress: string): boolean {
    return cleanupEmailAddress(emailAddress)?.length > 0 || false;
}